import { Tag, TagProps } from "antd";
import React from "react";

interface IProps extends TagProps {
  tagName: string | React.ReactNode;
}
export default function TagUI(props: IProps) {
  //! state
  const { tagName, ...res } = props;
  //! function
  //! render
  return (
    // Rounded by default; a tag that forces its own rounding (`!rounded-…`) keeps it.
    <Tag {...res} className={`${/(^|\s)!rounded/.test(res.className ?? "") ? "" : "!rounded-lg "}${res.className ?? ""}`}>
      {tagName}
    </Tag>
  );
}
